import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const CatalogValueContext = createContext<typeof initialState>(initialState);

const CatalogActionContext = createContext<Dispatch<typeof initialAction>>(
  () => {},
);

export { CatalogActionContext, CatalogValueContext };
